module.exports = __webpack_public_path__ + "assets/img/1_1789.41950686.jpg";